import React from 'react';
import {ScrollView, StyleSheet, View} from 'react-native';
import {FormikProps} from 'formik';
import {DatePicker, MultiSelect, TextInput, Text, TagsInput} from 'ui-kits';
import {Priority} from 'components/backlogs_screen/Priority';
import {spacing} from 'theme/Units';
import {projectTeamMember} from 'redux/slices/projectSlice';
import {UserStoryStatusDropDown, userStoryFormValuesType} from 'components';
import {useSelector} from 'react-redux';
import {selectedProjectTeam} from 'redux/selectors/projectSelector';
import {v4 as uuid} from 'uuid';
import {Follower, ResponsibleEmployee} from 'redux/slices/userStorySlice';
type propTypes = Readonly<{
  mode: 'add' | 'view' | 'edit';
}> &
  FormikProps<userStoryFormValuesType>;

export function StoryForm(props: propTypes) {
  const {mode = 'add', setFieldValue, values, errors} = props;

  function renderResponsible(item: projectTeamMember) {
    return (
      <Text>
        {item?.first_name} {item?.last_name}
      </Text>
    );
  }

  const projectTeam = useSelector(selectedProjectTeam);

  const displayTeamMember = (items: projectTeamMember[]) => {
    const maxMember = 2;
    if (items.length > maxMember) {
      return (
        <Text>{`${items
          .slice(0, maxMember)
          .map(displayName as any)
          .join(', ')} and ${items.length - maxMember} other`}</Text>
      );
    }

    return (
      <Text>
        {items
          .map(displayName as any)
          .join(', ')}
      </Text>
    );
  };


  const responsibleDisplayitem = (
    item: projectTeamMember[] & ResponsibleEmployee[] & Follower[],
  ) => {
    return <Text>{displayName(item[0])}</Text>;
  };

  function displayName(
    item: projectTeamMember & ResponsibleEmployee & Follower,
  ): string {
    if (item.name) {
      return item?.name;
    }
    return item?.first_name?.concat(' ', item?.last_name);
  }

  return (
    <View style={styles.container}>
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={styles.scrollStyle}>
        <View style={styles.form}>
          {/* responsible */}
          <MultiSelect
            options={projectTeam}
            displayItem={responsibleDisplayitem}
            keyExtractor={(item: projectTeamMember) =>
              item?.emp_id ? item?.emp_id.toString() : uuid()
            }
            renderItem={renderResponsible}
            onSave={([entries]) => setFieldValue('responsible', entries)}
            searchKeyExtractor={(item: projectTeamMember) =>
              item.first_name + item.last_name
            }
            rightIcon="cheveron_down"
            label="Responsible"
            placeholder="Unassigned"
            singleSelect={true}
            selectedEntries={values.responsible ? [values.responsible] : []}
            error={errors.responsible}
            dropDownStyle={styles.responsibleDropDown}
            searchHeader="Select Responsible"
          />
          <Priority
            priority={values.priority as any}
            error={errors.priority}
            onChange={value => setFieldValue('priority', value)}
            mode="edit"
            label="Priority"
          />
          {mode === 'view' ? (
            <>
              <DatePicker
                label="Created Date"
                value={new Date(values?.created_at)}
                disabled
              />
              <DatePicker
                label="Last Updated Date"
                value={new Date(values?.updated_at)}
                disabled
              />
            </>
          ) : null}
          <TextInput
            disabled
            value=""
            label="Epic"
            placeholder="Coming Soon..."
          />
          <TextInput
            disabled
            value=""
            label="Sprint"
            placeholder="Coming Soon..."
          />
          <DatePicker
            label="Due Date"
            calenderStyle={styles.calenderStyle}
            value={values.due_date}
            error={errors.due_date}
            onChangeDate={date => setFieldValue('due_date', date)}
          />
          <TextInput
            disabled
            value=""
            label="Release"
            placeholder="Coming Soon..."
          />
          <MultiSelect
            dropDownStyle={styles.followersDropDown}
            searchHeader="Select Follower"
            options={projectTeam}
            keyExtractor={(item: projectTeamMember) =>
              item?.emp_id ? item?.emp_id.toString() : uuid()
            }
            renderItem={renderResponsible}
            onSave={selected => {
              setFieldValue('followers', selected);
            }}
            searchKeyExtractor={(item: projectTeamMember) =>
              item?.first_name + item?.last_name
            }
            rightIcon="cheveron_down"
            label="Followers"
            selectedEntries={values.followers}
            error={errors.followers as any}
            placeholder="Select Follower(s)"
            displayItem={displayTeamMember}
          />
          <UserStoryStatusDropDown
            label="Status"
            onSave={status => setFieldValue('status', Number(status))}
            value={values.status as any}
            error={errors.status as any}
          />
        </View>
        {/* adding this so that soni does not raise bug for this */}
        <View style={styles.tagsInputWrapper}>
          <TagsInput label="Add Tags" values={values.tags} />
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  responsibleDropDown: {
    top: '10%',
    width: '40%',
    left: '10%',
  },
  followersDropDown: {
    top: '30%',
    width: '40%',
    left: '10%',
  },
  container: {
    flex: 1,
  },
  scrollStyle: {
    paddingHorizontal: spacing['4'],
    paddingBottom: spacing['4'],
  },
  tagsInputWrapper: {
    paddingBottom: spacing['3'],
  },
  scroll: {
    width: '100%',
  },
  form: {
    width: '70%',
    marginHorizontal: 'auto',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: spacing['4'],
    padding: spacing['4'],
  },
  calenderStyle: {
    left: '30%',
  },
});
